import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function FAQAccordion({ faqs = [], dark = false }) {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <div className={`divide-y ${dark ? "divide-br-line" : "divide-gray-200"}`} data-testid="faq-accordion">
      {faqs.map((f, idx) => {
        const open = openIdx === idx;
        return (
          <div key={f.q || idx} className="py-4">
            <button
              type="button"
              onClick={() => setOpenIdx(open ? -1 : idx)}
              className={`w-full text-left flex items-center justify-between gap-4 ${dark ? "text-white" : "text-gray-900"}`}
              data-testid={`faq-q-${idx}`}
            >
              <span className="font-display tracking-wider uppercase text-base">{f.q}</span>
              <ChevronDown className={`transition-transform ${open ? "rotate-180" : ""} ${dark ? "text-br-bronze-2" : "text-br-bronze"}`} />
            </button>
            {open && (
              <div className={`mt-3 text-sm leading-relaxed ${dark ? "text-gray-300" : "text-gray-700"}`}>{f.a}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
